export class GetList {
  static readonly type = '[UserTypes] List';
  constructor() { }
}